import request from '@/utils/request'

// 加载表格数据
export function getShopList(params){
    return request({
        url: '/server/shop/select',
        method: 'get',
        params: params
    })
}
// 加载表格数据
export function getLazada(params){
    return request({
        url: '/server/shop/select',
        method: 'get',
        params: params
    })
}

// 加载表格数据
export function getLazadaCategory(shopId){
    return request({
        url: '/server/shop/getLazadaCategory/' + shopId,
        method: 'get',
    })
}

// 加载表格数据
export function syncLazada(data){
    return request({
        url: '/server/universal/template/syncLazada',
        method: 'post',
        data: data
    })
}


// 加载表格数据
export function getChannelList(data){
    return request({
        url: '/server/order/channelList',
        method: 'GET',
        params: data
    })
}


// 加载表格数据
export function syncShopee(data){
    return request({
        url: '/server/universal/template/syncShopee',
        method: 'post',
        data: data
    })
}

